

































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'PopUp'
})
export default class PopUp extends Vue {
  // 是否显示弹窗
  @Prop({
    type: Boolean,
    default: false
  })
  isshow!: boolean
  // 当前语言
  @Prop({
    type: String,
    default: 'ug'
  })
  language!: string
  // 标题
  @Prop({
    type: String,
    default: '实名认证'
  })
  title!: string

  // 文案
  @Prop({
    type: String,
    default: 'Mungdax提倡真实交友，完成实名认证会更受异性欢迎，还可获得金豆奖励'
  })
  content!: string

  // 按钮
  @Prop({
    type: String,
    default: '立即认证'
  })
  btn!: string

  @Prop({
    type: Boolean,
    default: false
  })
  cancle!: boolean

  handelCertif() {
    this.$router.push({
      path: '/certification',
      query: { language: this.language, type: 12 as any }
    })
    // 积分-去实名
    const { aplus_queue }: any = window
    aplus_queue.push({
      action: 'aplus.record',
      arguments: ['remove_real_name', 'CLK']
    })
  }

  handelOverlay() {
    this.$emit('handelOverlay')
  }
}
